module.exports = __webpack_public_path__ + "img/blank-profile.6732bd42.png";